export default "__VITE_ASSET__BSCoGDPE__"